// extracted by mini-css-extract-plugin
export default {"setting-container":"modeOneSelect_setting-container__uDvvN","setting":"modeOneSelect_setting__4j-m+"};